import { IDeductionRepository, IDeductionsByRemittanceItemRepositoryParams, IDeductionsByRemittanceItemRepositoryResponse } from "@/core/repositories/deduction";

export class GetDeductionByRemittanceItemUseCase {
  constructor(private readonly deductionRepository: IDeductionRepository) {}

  async execute(params: IDeductionsByRemittanceItemRepositoryParams, refetch: boolean = false): Promise<IDeductionsByRemittanceItemRepositoryResponse> {
    return this.deductionRepository.getDeductionsByRemittanceItem(params, refetch);
  }
}
